import { Input } from "@/components/ui/input";
import { useTranslation } from "react-i18next";

interface FunctionFilterProps {
  functionFilter: string;
  setFunctionFilter: (functionName: string) => void;
}

export const FunctionFilter = ({ 
  functionFilter, 
  setFunctionFilter 
}: FunctionFilterProps) => {
  const { t } = useTranslation();
  return (
    <Input
      placeholder={t("candidates.filters.functionPlaceholder")}
      value={functionFilter}
      onChange={(e) => setFunctionFilter(e.target.value)}
      className="w-32 sm:w-40"
    />
  );
};
